module.exports = "./img/1a8442aee63d218eb2eb653567b254fc.png";